__turbopack_context__.v({
  "authPlaceholder": "Header-module__D5nTzG__authPlaceholder",
  "desktop": "Header-module__D5nTzG__desktop",
  "headerButtons": "Header-module__D5nTzG__headerButtons",
  "landingPageHeader": "Header-module__D5nTzG__landingPageHeader",
  "landingPageMenuButton": "Header-module__D5nTzG__landingPageMenuButton",
  "landingPageMenuButtonNoAuth": "Header-module__D5nTzG__landingPageMenuButtonNoAuth",
  "mobile-burger": "Header-module__D5nTzG__mobile-burger",
  "mobile-logo": "Header-module__D5nTzG__mobile-logo",
  "profileContainer": "Header-module__D5nTzG__profileContainer",
  "profileContainerLadningPage": "Header-module__D5nTzG__profileContainerLadningPage",
  "signInButton": "Header-module__D5nTzG__signInButton",
  "signInHeader": "Header-module__D5nTzG__signInHeader",
  "signInHeaderLP": "Header-module__D5nTzG__signInHeaderLP",
});
